/** @see https://developers.qliro.com/docs/qliro-checkout */
export const QLIRO_API_URL = process.env.QLIRO_API_URL ?? ''
export const QLIRO_API_KEY = process.env.QLIRO_API_KEY ?? ''
export const QLIRO_API_SECRET = process.env.QLIRO_API_SECRET ?? ''
